import { Link } from 'react-router-dom';
import { useTranslation } from '../../../i18n/useTranslation';
import type { TranslationKey } from '../../../i18n/he';
import { routes } from '../../../Utils/routes';
import { PricingTiers } from '../../SharedArea/PricingTiers/PricingTiers';
import './Pricing.css';

const TRIAL_DAYS = 7;

const FREE_FEATURES: TranslationKey[] = [
  'planFree1', 'planFree2', 'planFree3', 'planFree4', 'planFree5'
];

export function Pricing() {
  const { tr } = useTranslation();

  return (
    <div className="pricing-page">
      <header className="pricing-hero">
        <div className="pricing-hero-copy">
          <p className="pricing-eyebrow">{tr('pricingTitle')}</p>
          <h1>{tr('pricingHeadline')}</h1>
          <p>{tr('pricingLede', TRIAL_DAYS)}</p>
        </div>

        <div className="pricing-flow" aria-label={tr('pricingFlowLabel')}>
          <span>{tr('pricingFlowLesson')}</span>
          <i aria-hidden="true" />
          <span>{tr('pricingFlowPayment')}</span>
          <i aria-hidden="true" />
          <strong>{tr('pricingFlowReceipt')}</strong>
        </div>
      </header>

      <div className="pricing-plan-grid">
        <section className="pricing-plan pricing-plan-free">
          <div className="pricing-plan-heading">
            <p className="pricing-plan-kicker">{tr('planFreeKicker')}</p>
            <h2>{tr('planFreeName')}</h2>
            <p className="pricing-plan-price"><bdi>{tr('planFreePrice')}</bdi><span>{tr('planForever')}</span></p>
            <p className="pricing-plan-sub">{tr('planFreeSub')}</p>
          </div>
          <ul className="pricing-feature-list">
            {FREE_FEATURES.map(key => (
              <li key={key}><CheckIcon /> <span>{tr(key)}</span></li>
            ))}
          </ul>
          <Link className="ghost-button" to={routes.app}>{tr('planFreeCta')}</Link>
        </section>

        <PricingTiers successPath={routes.welcome} />
      </div>

      <section className="pricing-notes">
        <h2>{tr('pricingNotesTitle')}</h2>
        <ul>
          <li>{tr('pricingNote1')}</li>
          <li>{tr('pricingNote2')}</li>
          <li>{tr('pricingNote3')}</li>
        </ul>
        <p>
          <Link to={routes.refunds}>{tr('navRefunds')}</Link>
          <span aria-hidden="true"> · </span>
          <Link to={routes.terms}>{tr('navTerms')}</Link>
        </p>
      </section>
    </div>
  );
}

function CheckIcon() {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <path d="m5 10.5 3.1 3.1L15 6.8" />
    </svg>
  );
}
